var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-modal",
      class: { active: _vm.is_active },
      on: { click: _vm.closeModal }
    },
    [
      _c("span", { staticClass: "round_btn", on: { click: _vm.closeModal } }),
      _vm._v(" "),
      _c("video", {
        ref: "video",
        attrs: {
          controls: "",
          width: "700",
          height: "700",
          src: require("@/assets/movie/how_to_play.mp4")
        },
        on: { click: _vm.closeModal }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701ac82d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-701ac82d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 